import { createApp } from 'vue';
import FloatingVue from 'floating-vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import VueSidePanel from 'vue3-side-panel';
import { Collapse } from 'vue-collapsed';
import Search from './Search.vue';

import 'floating-vue/dist/style.css';
import '@vuepic/vue-datepicker/dist/main.css';
import 'vue3-side-panel/dist/vue3-side-panel.css';

/**
 * Mount the Vue app
 * @param {import('./index.js').default} instance
 * @param {object} options
 * @param {Array} options.nearTo
 * @param {Array} options.envie
 * @param {Array} options.trad
 * @param {Array} options.france
 * @param {boolean} options.isOpen
 * @returns {import('vue').App}
 */
export function mount(instance, { france, nearTo, envie, trad, isOpen }) {
  const app = createApp(Search, {
    france,
    nearTo,
    envie,
    trad,
    isOpen,
    action: instance.$refs.form.action,
    defaultTermId: instance.$options.searchTermId,
    datepickerContent: instance.$refs['datepicker-content'].textContent.trim(),
    datepickerType: instance.$options.datepickerType,
  });

  app.use(FloatingVue);
  app.use(VueSidePanel);
  app.component('VueDatePicker', VueDatePicker);
  app.component('Collapse', Collapse);

  app.mount(instance.$el);

  return app;
}
